import en from './en';

// English remains the fallback baseline; translated keys below override it.
const ja = {
  ...en,
  "언어": "言語",
  "로그인": "ログイン",
  "로그아웃": "ログアウト",
  "비밀번호": "パスワード",
  "서버 오류": "サーバーエラー",
  "로그인 실패: ": "ログイン失敗: ",
  "🔐 어드민 로그인": "🔐 管理者ログイン",
  "유저 관리": "ユーザー管理",
  "테이블 관리": "テーブル管理",
  "전광판": "マーキー",
  "자산기록": "資産記録",
  "결제관리": "決済管理",
  "라운지 관리": "ラウンジ管理",
  "공지 관리": "お知らせ管理",
  "광고 관리": "広告管理",
  "검색": "検索",
  "검색어를 입력하세요": "検索語を入力してください",
  "새로고침": "更新",
  "로딩 중...": "読み込み中...",
  "로딩중...": "読み込み中...",
  "불러오는 중…": "読み込み中…",
  "불러오기 실패": "読み込み失敗",
  "데이터 없음": "データなし",
  "데이터가 없습니다.": "データがありません。",
  "표시할 기록이 없습니다.": "表示する記録がありません。",
  "생성": "作成",
  "생성 중...": "作成中...",
  "생성 중…": "作成中…",
  "생성 실패: ": "作成失敗: ",
  "생성 에러:": "作成エラー:",
  "수정": "編集",
  "저장": "保存",
  "저장 중...": "保存中...",
  "저장 실패": "保存失敗",
  "삭제": "削除",
  "삭제 실패": "削除失敗",
  "삭제됨": "削除済み",
  "취소": "キャンセル",
  "닫기": "閉じる",
  "확인": "確認",
  "복사": "コピー",
  "복사 실패(브라우저 권한 확인)": "コピー失敗（ブラウザ権限を確認）",
  "상태": "状態",
  "상세": "詳細",
  "관리": "管理",
  "관리 상태": "管理状態",
  "노출": "表示",
  "노출중": "表示中",
  "비활성": "無効",
  "활성": "有効",
  "게시": "公開",
  "게시 중": "公開中",
  "게시 상태": "公開状態",
  "만료": "期限切れ",
  "만료일:": "期限日:",
  "게시일:": "公開日:",
  "예약": "予約",
  "예약 없음": "予約なし",
  "예약 시간이 올바르지 않습니다.": "予約時間が正しくありません。",
  "상시": "常時",
  "미리보기": "プレビュー",
  "그룹 생성": "グループ作成",
  "그룹 이름": "グループ名",
  "그룹명": "グループ名",
  "그룹 노출(DisplaySet)": "グループ表示（DisplaySet）",
  "그룹 시간 설정이 올바르지 않습니다.": "グループ時間設定が正しくありません。",
  "그룹 이름, Small Blind, Big Blind는 필수 입력입니다. SB/BB는 예: 0.25, 0.50처럼 입력할 수 있습니다.": "グループ名、Small Blind、Big Blindは必須です。SB/BBは例: 0.25、0.50のように入力できます。",
  "테이블 그룹": "テーブルグループ",
  "테이블 생성": "テーブル作成",
  "테이블 목록": "テーブル一覧",
  "테이블 미션": "テーブルミッション",
  "테이블 미션 설정": "テーブルミッション設定",
  "테이블 미션 총 베팅금(target_total_bet)을 입력": "テーブルミッション総ベット額（target_total_bet）を入力",
  "테이블 미션 설정 저장": "テーブルミッション設定を保存",
  "테이블 미션 설정 저장 실패": "テーブルミッション設定の保存失敗",
  "Small Blind": "Small Blind",
  "Big Blind": "Big Blind",
  "Rake % (수수료율)": "Rake %（手数料率）",
  "라운지 포인트 %": "ラウンジポイント %",
  "라운지 포인트 % (0~100)": "ラウンジポイント %（0〜100）",
  "라운지 포인트 지급률": "ラウンジポイント付与率",
  "라운지 포인트 지급률 저장 실패": "ラウンジポイント付与率の保存失敗",
  "현재 라운지 포인트 %": "現在のラウンジポイント %",
  "SB/BB는 0보다 큰 숫자이며 소수점은 최대 2자리까지 입력할 수 있습니다. 예: 0.25 / 0.50": "SB/BBは0より大きい数値で、小数点以下2桁まで入力できます。例: 0.25 / 0.50",
  "라운지 포인트 %는 0~100 사이 숫자이며 소수점은 최대 2자리까지 가능합니다.": "ラウンジポイント%は0〜100の数値で、小数点以下2桁まで可能です。",
  "※ 입력이 없으면 0%로 처리됩니다.": "※ 未入力の場合は0%として処理されます。",
  "※ 입력이 없으면 0.00%로 처리됩니다.": "※ 未入力の場合は0.00%として処理されます。",
  "startAt (시작)": "startAt（開始）",
  "endAt (종료, 선택)": "endAt（終了、任意）",
  "endAt은 startAt보다 늦어야 해.": "endAtはstartAtより後である必要があります。",
  "시작": "開始",
  "종료": "終了",
  "시작(로컬)": "開始（ローカル）",
  "종료(로컬)": "終了（ローカル）",
  "시작일": "開始日",
  "기간": "期間",
  "무한(30일 갱신)": "無限（30日更新）",
  "24시간 반복": "24時間繰り返し",
  "Due Date 지정": "Due Date指定",
  "Due Date(관리자 로컬 시간)": "Due Date（管理者ローカル時間）",
  "Due Date를 입력해야 합니다.": "Due Dateを入力してください。",
  "Due Date를 올바른 날짜/시간으로 입력해야 합니다.": "正しいDue Date日時を入力してください。",
  "공지 작성/관리": "お知らせ作成/管理",
  "공지 제목": "お知らせタイトル",
  "공지 본문": "お知らせ本文",
  "공지 수정": "お知らせ編集",
  "새 공지 작성": "新しいお知らせ作成",
  "+ 공지 작성": "+ お知らせ作成",
  "+ 새 공지 작성": "+ 新しいお知らせ作成",
  "공지가 없어. 위에서 새로 작성해줘.": "お知らせがありません。上で新規作成してください。",
  "공지 목록 불러오는 중...": "お知らせ一覧を読み込み中...",
  "광고 이미지 등록/관리": "広告画像登録/管理",
  "광고 수정": "広告編集",
  "새 광고 등록": "新しい広告登録",
  "+ 광고 등록": "+ 広告登録",
  "+ 새 광고 등록": "+ 新しい広告登録",
  "광고 이미지": "広告画像",
  "광고 이미지를 업로드해줘.": "広告画像をアップロードしてください。",
  "광고 저장에 실패했어.": "広告の保存に失敗しました。",
  "광고 삭제에 실패했어.": "広告の削除に失敗しました。",
  "등록된 광고가 없어.": "登録された広告がありません。",
  "광고 목록 불러오는 중...": "広告一覧を読み込み中...",
  "광고 목록을 불러오지 못했어.": "広告一覧を読み込めませんでした。",
  "라운지 글": "ラウンジ投稿",
  "라운지 글 목록": "ラウンジ投稿一覧",
  "라운지 아이템": "ラウンジアイテム",
  "라운지 업로드": "ラウンジアップロード",
  "라운지 목록 불러오는 중...": "ラウンジ一覧を読み込み中...",
  "라운지 목록을 불러오지 못했습니다.": "ラウンジ一覧を読み込めませんでした。",
  "등록된 라운지 글이 없습니다.": "登録されたラウンジ投稿がありません。",
  "라운지포인트": "ラウンジポイント",
  "결제 영역": "決済エリア",
  "결제 옵션": "決済オプション",
  "결제 옵션 추가": "決済オプション追加",
  "결제 완료": "決済完了",
  "결제 항목": "決済項目",
  "등록된 결제 옵션이 없습니다.": "登録された決済オプションがありません。",
  "금액": "金額",
  "수량": "数量",
  "미결제": "未決済",
  "자산": "資産",
  "레이크백": "レーキバック",
  "일반 자산": "通常資産",
  "라운지포인트": "ラウンジポイント",
  "관리자 자산 표시 영역": "管理者資産表示エリア",
  "내 자산 0,000,000": "自分の資産 0,000,000",
  "나의 지갑 주소": "自分のウォレットアドレス",
  "보내는 지갑": "送信ウォレット",
  "받는 지갑": "受信ウォレット",
  "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "フロントテスト: 送金完了処理（バックエンド接続前）",
  "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "フロントテスト: 出金開始処理（バックエンド接続前）",
  "에이전트": "エージェント",
  "에이전트로 생성": "エージェントとして作成",
  "하위 계정 생성": "下位アカウント作成",
  "하위 생성": "下位作成",
  "하위 {id}": "下位 {id}",
  "소속 유저": "所属ユーザー",
  "소속유저": "所属ユーザー",
  "상위 에이전트:": "上位エージェント:",
  "수수료": "手数料",
  "수수료 수정": "手数料編集",
  "수수료 수정 실패": "手数料編集失敗",
  "분배 비율": "分配比率",
  "분배 비율(상대 %)": "分配比率（相対%）",
  "국가(country)를 입력해줘. 예: KR / US / JP / ALL": "国（country）を入力してください。例: KR / US / JP / ALL",
  "Country 필터": "国フィルター",
  "Device 필터": "デバイスフィルター",
  "동아시아": "東アジア",
  "동남아": "東南アジア",
  "유럽": "ヨーロッパ",
  "북미": "北米",
  "남미": "南米",
  "아프리카": "アフリカ",
  "글로벌": "グローバル",
  "제목": "タイトル",
  "본문": "本文",
  "내용(message)": "内容（message）",
  "본문 내용을 입력하세요": "本文内容を入力してください",
  "본문을 입력해줘.": "本文を入力してください。",
  "message는 필수입니다.": "messageは必須です。",
  "message는 빈값이 될 수 없습니다.": "messageは空にできません。",
  "이미지": "画像",
  "이미지 URL": "画像URL",
  "등록된 이미지 없음": "登録画像なし",
  "업로드": "アップロード",
  "업로드중...": "アップロード中...",
  "업로드 URL을 받지 못했습니다.": "アップロードURLを受け取れませんでした。",
  "업로드 URL을 받지 못했어.": "アップロードURLを受け取れませんでした。",
  "링크 열기": "リンクを開く",
  "링크:": "リンク:",
  "링크는 http:// 또는 https:// 로 시작해야 해.": "リンクはhttp://またはhttps://で始まる必要があります。",
  "비워두면 클릭 이동 없음": "空欄の場合クリック移動なし",
  "인포카드": "インフォカード",
  "+ 인포카드 추가": "+ インフォカード追加",
  "+ 인포 버튼 추가": "+ インフォボタン追加",
  "+ 아이콘(업로드)": "+ アイコン（アップロード）",
  "+ 이미지": "+ 画像",
  "+ 텍스트": "+ テキスト",
  "+ 타이머(표시여부)": "+ タイマー（表示有無）",
  "하이라이트 포인트": "ハイライトポイント",
  "하이라이트 메세지": "ハイライトメッセージ",
  "유효 인포메이션 버튼:": "有効な情報ボタン:",
  "프리셋 수정": "プリセット編集",
  "프리셋(배경/요소/URL)": "プリセット（背景/要素/URL）",
  "배경 색상": "背景色",
  "배경 이미지 URL": "背景画像URL",
  "배경 타입": "背景タイプ",
  "폰트스타일": "フォントスタイル",
  "굵기": "太さ",
  "색상": "色",
  "표시명": "表示名",
  "표시 순서(order)": "表示順（order）",
  "표시 여부만": "表示状態のみ",
  "페이지": "ページ",
  "페이지 크기": "ページサイズ",
  "다음": "次へ",
  "이전": "前へ",
  "위로": "上へ",
  "아래로": "下へ",
  "펼치기": "展開",
  "개": "個",
  "건": "件",
  "명": "名",
  "0 이상 숫자를 입력하세요.": "0以上の数値を入力してください。",
  "0보다 큰 금액을 입력하세요.": "0より大きい金額を入力してください。",
  "0보다 큰 숫자만 가능": "0より大きい数値のみ可能です。",
  "⚠️ 권한이 없습니다": "⚠️ 権限がありません",
  "이 페이지에 접근할 수 있는 권한이 없습니다.": "このページにアクセスする権限がありません。",
};

export default ja;
